import React, { useRef, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useClickOutside } from 'react-haiku';
import { useSpring, animated } from 'react-spring';
import { useCollect, useRequest } from 'hooks';

import Avatar from 'components/Misc/Avatar';
import Icon from 'components/Misc/Icon';

import { useAppStore } from 'store/useAppStore';

const User = () => {
	// Store container's ref
	const ref = useRef(null);

	// Use route history
	const history = useHistory();
	
	// Use app's store
	const [user, onReset] = useAppStore(state => [state.user, state.onReset]);

	// Cache alignment's container visibility
	const [visible, setVisible] = useState(false);

	// Store menu's animation styles
	const style = useSpring({
		opacity: visible ? 1 : 0,
		pointerEvents: visible ? 'auto' : 'none',
		config: {
			duration: 150
		}
	});

	// Collect user's data
	const [[result], collect] = useCollect(`users/${user.id}`);

	// Store logout request
	const [[progress], request] = useRequest('post', 'auth/logout');

	// Handle logout logit
	const onLogout = async () => {
		// Do not run request more than once
		if (progress) return;

		// Try to logout
		await request();

		// Clear local storage
		localStorage.removeItem('token');
		localStorage.removeItem('user');

		// Redirect to main
		history.push('/');

		// Either request fails or succeeds
		onReset();
	};

	// Handles menu visibility toggle
	const onClick = () => setVisible(prev => !prev);

	// Handles click outside of alignment's container
	const onOutside = () => setVisible(false);

	// Use outside handler
	useClickOutside(ref, onOutside);

	// Collect user's data
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	return (
		<div ref={ref} className="relative">
			<div onClick={onClick} className="hover:opacity-75 transition-opacity cursor-pointer">
				<Avatar
					alt={result?.fullName}
					src={result?.avatar}
				/>
			</div>

			<animated.div style={style} className="absolute z-10 w-auto top-14 right-0 bg-white dark:bg-neutral-700 dark:border-neutral-700 shadow-md rounded-lg transition-colors">
				<Link to="/me" className="px-3 h-9 flex items-center text-neutral-900 dark:text-white cursor-pointer transition-colors">
					<Icon icon="settings" className="mr-2" />
					Iestatījumi
				</Link>

				<div
					onClick={onLogout}
					className="px-3 h-9 flex items-center text-neutral-900 dark:text-white cursor-pointer transition-colors"
				>
					<Icon icon="exit_to_app" className="mr-2" />
					Iziet
				</div>
			</animated.div>
		</div>
	);
};

export default User;